import {
  Building2,
  ClipboardList,
  Coins,
  FileSignature,
  FileSpreadsheet,
  FileText,
  HandCoins,
  LayoutDashboard,
  Receipt,
  Repeat,
  ScrollText,
  Tags,
  Users,
} from 'lucide-react';
import type { SidebarNavGroup } from '@zafroi/ui-kit';

/**
 * Sidebar nav config for ZAFROI Kosh.
 *
 * Navigation mirrors the four bounded contexts (see docs/navigation.md):
 *   Overview   → Dashboard (financial visibility, the landing screen)
 *   Commercial → Customers, Quotes, Proposals, Contracts
 *   Financial  → Invoices, Receivables, Collections
 *   Setup      → Price Books, Rate Cards, Reminder Templates, Organization
 */
export const sidebarNav: SidebarNavGroup[] = [
  {
    id: 'overview',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: LayoutDashboard,
        href: '/dashboard',
      },
    ],
  },
  {
    id: 'commercial',
    label: 'Commercial',
    items: [
      { id: 'customers', label: 'Customers', icon: Users, href: '/customers' },
      { id: 'quotes', label: 'Quotes', icon: FileText, href: '/quotes' },
      { id: 'proposals', label: 'Proposals', icon: ClipboardList, href: '/proposals' },
      { id: 'contracts', label: 'Contracts', icon: FileSignature, href: '/contracts' },
      { id: 'subscriptions', label: 'Subscriptions', icon: Repeat, href: '/subscriptions' },
    ],
  },
  {
    id: 'financial',
    label: 'Financial',
    items: [
      { id: 'invoices', label: 'Invoices', icon: Receipt, href: '/invoices' },
      {
        id: 'receivables',
        label: 'Receivables',
        icon: Coins,
        href: '/receivables',
      },
      {
        id: 'collections',
        label: 'Collections',
        icon: HandCoins,
        href: '/collections',
      },
    ],
  },
  {
    id: 'setup',
    label: 'Setup',
    items: [
      { id: 'price-books', label: 'Price Books', icon: Tags, href: '/setup/price-books' },
      { id: 'rate-cards', label: 'Rate Cards', icon: FileSpreadsheet, href: '/setup/rate-cards' },
      { id: 'reminders', label: 'Reminders', icon: ScrollText, href: '/setup/reminders' },
      { id: 'organization', label: 'Organization', icon: Building2, href: '/setup/organization' },
    ],
  },
];
